import { createContext } from "react";

export const InvitesContext = createContext();
